import {
  Alert,
  Autocomplete,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { getData } from "../../../../../services/library";
import { UrlApi } from "../../../../../services/apirest";
import { debounce } from "lodash";
import SelectorFiltrosMultiples from "../../../pedidosEnvasado/NuevoPedido/agregados/SelectorFiltrosMultiples";
import ChipsFiltrosActivos from "../../../pedidosEnvasado/NuevoPedido/agregados/ChipsFiltrosActivos";
import AgregarCoordenadasEnv from "../../../pedidosEnvasado/NuevoPedido/agregarCoordenadas/AgregarCoordenadasEnv";
import TabAltaEnv from "../../../clientesEnvasado/alta/TabAltaEnv";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import CoordenadasClientes from "../coordenadas/CoordenadasClientes";
import DeleteIcon from '@mui/icons-material/Delete';

function AddClienteHoja(props) {
  const [alta, setAlta] = useState(props.alta);
  const [clienteSeleccionado, setClienteSeleccionado] = useState("");
  const [direcciones, setDirecciones] = useState(null);
  const [direccionSeleccionada, setDireccionSeleccionada] = useState("");
  const [clientesAgregados, setClientesAgregados] = useState([]);
  const [openSnack, setOpenSnack] = useState(false);
  const [colormensaje, setColormensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [searchCliente, setSearchCliente] = useState("");
  const [tabla, setTabla] = useState(true);
  const [altaCliente, setAltaCliente] = useState(false);
  const [agregarCoordenadas, setAgregarCoordenadas] = useState(false);
  const [disBtn, setDisBtn] = useState(true)
  const [abrirCoordenadas, setAbrirCoordenadas] = useState(false);
  // Nuevos estados para el sistema de búsqueda
  const [filtrosSeleccionados, setFiltrosSeleccionados] = useState([
    "cliente",
    "direccion",
  ]);
  const [todasDirecciones, setTodasDirecciones] = useState([]);
  const [loadingDirecciones, setLoadingDirecciones] = useState(false);
  const [inputValueDirecciones, setInputValueDirecciones] = useState("");

  // Opciones de filtros
  const opcionesFiltros = [
    { value: "cliente", label: "👤 Cliente", icon: "👤" },
    { value: "direccion", label: "🏠 Dirección", icon: "🏠" },
    { value: "localidad", label: "🏙️ Localidad", icon: "🏙️" },
    { value: "telefono", label: "📞 Teléfono", icon: "📞" },
    { value: "cuit", label: "📋 CUIT", icon: "📋" },
    { value: "sisven", label: "🔢 SISVEN", icon: "🔢" },
  ];

  const handleFiltrosChange = (nuevosFiltros) => {
    setFiltrosSeleccionados(nuevosFiltros);
  };

  // Función para buscar direcciones con filtros
  const buscarDireccionesFiltradas = async (searchTerm, filtros) => {
    if (!searchTerm || searchTerm.trim().length < 2 || filtros.length === 0) {
      setTodasDirecciones([]);
      return;
    }

    setLoadingDirecciones(true);
    try {
      const sucursales = props.hoja.id_sucursal || [];
      const searchParams = new URLSearchParams({
        search: searchTerm.trim(),
        limit: 100,
        filtros: filtros.join(","),
      });

      const response = await fetch(
        UrlApi +
          `/envasado_direcciones_entrega/buscarDireccionesSucAuth/${sucursales}?${searchParams}`
      );

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      setTodasDirecciones(data);
    } catch (error) {
      console.error("Error buscando direcciones:", error);
      setTodasDirecciones([]);
    } finally {
      setLoadingDirecciones(false);
    }
  };

  // Debounce para búsqueda
  const debouncedSearch = useCallback(
    debounce((searchTerm, filtros) => {
      buscarDireccionesFiltradas(searchTerm, filtros);
    }, 400),
    []
  );

  // Placeholder dinámico
  const getPlaceholderText = (filtros) => {
    if (filtros.length === 0) {
      return "Seleccione filtros para buscar...";
    }

    if (filtros.length === opcionesFiltros.length) {
      return "Buscar en todos los campos...";
    }

    const filtrosLabels = filtros.map((filtro) => {
      const opcion = opcionesFiltros.find((f) => f.value === filtro);
      return opcion?.label
        .toLowerCase()
        .replace("por ", "")
        .replace(/[👤🏠🏙️📞📋🔢]/g, "")
        .trim();
    });

    return `Buscar por: ${filtrosLabels.join(", ")}...`;
  };

  useEffect(() => {
    if (inputValueDirecciones.length >= 2 && filtrosSeleccionados.length > 0) {
      debouncedSearch(inputValueDirecciones, filtrosSeleccionados);
    } else {
      setTodasDirecciones([]);
    }

    return () => {
      debouncedSearch.cancel();
    };
  }, [inputValueDirecciones, filtrosSeleccionados, debouncedSearch]);

  // Manejo de selección de dirección
  const handleDireccionSeleccionada = (newValue) => {
    if (!newValue) {
      setDireccionSeleccionada("");
      setClienteSeleccionado("");
      return;
    }

    setDireccionSeleccionada(newValue);

    if (newValue && newValue.id_cliente) {
      const clienteAsociado = {
        id: newValue.id_cliente,
        razon_social: newValue.razon_social,
        sisven_id: newValue.sisven_id,
        sucursal: newValue.cliente_sucursal || newValue.sucursal,
      };

      setClienteSeleccionado(clienteAsociado);

      // Obtener todas las direcciones del cliente
      if (newValue.id_cliente) {
        getData(
          "/envasado_direcciones_entrega/cli/" + newValue.id_cliente,
          setDirecciones
        );
      }
    }
  };

  // Manejo de agregar cliente automáticamente al elegir dirección
  const handleAgregarCliente = (direccion) => {
    if (!clienteSeleccionado || !direccion) return;

    const existe = clientesAgregados.find(
      (item) =>
        item.cliente.id === clienteSeleccionado.id &&
        item.direccion.id === direccion.id
    );

    if (existe) {
      return;
    }

    // Verificar si ya existe en la ruta actual
    const existeEnRuta = props.clientes.some(
      (existente) => existente.id_direccion === direccion.id
    );

    if (existeEnRuta) {
      setColormensaje("#F5B041");
      setMensaje("Esta dirección ya está en la hoja de ruta");
      setOpenSnack(true);
      return;
    }

    setClientesAgregados((prev) => [
      ...prev,
      { cliente: clienteSeleccionado, direccion },
    ]);

    // Reset
    setClienteSeleccionado("");
    setDireccionSeleccionada("");
    setDirecciones(null);
    setInputValueDirecciones("");
    setTodasDirecciones([]);
  };

  useEffect(() => {
    if (direccionSeleccionada) {
      handleAgregarCliente(direccionSeleccionada);
    }
  }, [direccionSeleccionada]);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
  };

  const handleClose = () => {
    setAlta(!alta);
    if (props.onClose) props.onClose();
  };

  const handleEliminarCliente = (index) => {
    setClientesAgregados((prev) => prev.filter((_, i) => i !== index));
  };

  const handleGuardar = async (e) => {
    e.preventDefault();
setDisBtn(true)
    try {
      const payload = clientesAgregados.map((item) => ({
        id_hoja: props.hoja.id,
        id_direccion: item.direccion.id,
        activo: 1,
        usuario: localStorage.getItem("user"),
      }));

      const resp = await fetch(UrlApi + "/envasado_clientes_ruta/array", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      setColormensaje("#58D68D");
      setMensaje("Clientes guardados correctamente");
      setOpenSnack(true);

      // reset
      setClientesAgregados([]);
      setInputValueDirecciones("");
      setTimeout(() => {
        handleClose();
      }, 1500);
    } catch (err) {
      setColormensaje("#EC7063");
      setMensaje("Hubo un error al guardar");
      setOpenSnack(true);
      console.error(err);
    }
  };

const ClientesSeleccionadosList = React.memo(
  ({ clientesFiltrados, handleEliminarCliente }) =>
    clientesFiltrados.map((item, index) => (
      <Box
        key={`${item.cliente.id}-${item.direccion.id}-${index}`}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Typography fontSize={16}>
          {item.cliente.razon_social} – {item.direccion.direccion_entrega}
        </Typography>
        
        <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
  {(item.direccion.latitud === null || item.direccion.longitud === null) && (
    <Tooltip title="Agregar coordenadas">
      <IconButton
        size="small"
        onClick={() => handleClickAgregarCoordenadas(item.direccion)}
        // sx={{
        //   width: 32,
        //   height: 32,
        //   background: "linear-gradient(135deg, #FFB74D, #FF9800)",
        //   color: "white",
        //   boxShadow: "0 2px 4px rgba(255, 152, 0, 0.2)",
        //   "&:hover": {
        //     background: "linear-gradient(135deg, #FF9800, #F57C00)",
        //     boxShadow: "0 4px 8px rgba(255, 152, 0, 0.4)",
        //     transform: "scale(1.05)"
        //   },
        //   transition: "all 0.3s ease"
        // }}
      >
        <AddLocationAltIcon fontSize="small" color="secondary"/>
      </IconButton>
    </Tooltip>
  )}
  
  <Tooltip title="Eliminar">
    <IconButton
      size="small"
      onClick={() => handleEliminarCliente(index)}
      // sx={{
      //   width: 32,
      //   height: 32,
      //   background: "linear-gradient(135deg, #EF5350, #F44336)",
      //   color: "white",
      //   boxShadow: "0 2px 4px rgba(244, 67, 54, 0.2)",
      //   "&:hover": {
      //     background: "linear-gradient(135deg, #F44336, #D32F2F)",
      //     boxShadow: "0 4px 8px rgba(244, 67, 54, 0.4)",
      //     transform: "scale(1.05)"
      //   },
      //   transition: "all 0.3s ease"
      // }}
      
    >
      <DeleteIcon fontSize="small" color="error"/>
    </IconButton>
  </Tooltip>
</Box>
      </Box>
    ))
);

  const handleClickNuevo = () => {
    setAltaCliente(true);
    setTabla(false);
    setDireccionSeleccionada("");
    setClienteSeleccionado("");
  };

const handleClickAgregarCoordenadas = (direccion) => {
  setDireccionSeleccionada(direccion);
  setAbrirCoordenadas(true);
  setTabla(false);
};

const handleCloseAgregarCoordenadas = (coordenadasActualizadas = null) => {
  if (coordenadasActualizadas) {
    // Actualizar la dirección en clientesAgregados con las nuevas coordenadas
    setClientesAgregados(prev => 
      prev.map(item => 
        item.direccion.id === coordenadasActualizadas.id 
          ? { 
              ...item, 
              direccion: { 
                ...item.direccion, 
                latitud: coordenadasActualizadas.latitud,
                longitud: coordenadasActualizadas.longitud
              } 
            } 
          : item
      )
    );
  }
  
  setAbrirCoordenadas(false);
  setTabla(true);
  setDireccionSeleccionada("");
  setClienteSeleccionado("");
};

useEffect(() => {
  if (clientesAgregados.length === 0) {
    setDisBtn(true);
  } else {
    // Verificar si TODOS los clientes tienen coordenadas
    const todosTienenCoordenadas = clientesAgregados.every(item => 
      item.direccion.latitud !== null && 
      item.direccion.longitud !== null &&
      item.direccion.latitud !== undefined && 
      item.direccion.longitud !== undefined
    );
    
    setDisBtn(!todosTienenCoordenadas); // Se habilita solo cuando TODOS tienen coordenadas
  }
}, [clientesAgregados]);

    const AdvertenciaCoordenadas = clientesAgregados.every(item => 
      item.direccion.latitud !== null && 
      item.direccion.longitud !== null &&
      item.direccion.latitud !== undefined && 
      item.direccion.longitud !== undefined
    );
    
  return (
    <>
    {tabla &&(
      <Dialog fullWidth open={alta} onClose={handleClose} maxWidth="md">
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Agregar Clientes a {props.hoja.nombre}
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={handleGuardar}>
          <DialogContent>
            <Grid container spacing={2}>
              {/* Sistema de búsqueda unificado */}
              <Grid item xs={12}>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
                >
                  {/* Fila principal usando Grid para mejor alineación */}
                  <Grid container spacing={1} alignItems="center">
                    {/* Selector de filtros */}
                    <Grid item xs={12} sm="auto">
                      <Box sx={{ minWidth: 160, height: 40 }}>
                        <SelectorFiltrosMultiples
                          filtrosSeleccionados={filtrosSeleccionados}
                          onFiltrosChange={handleFiltrosChange}
                        />
                      </Box>
                    </Grid>

                    {/* Campo de búsqueda */}
                    <Grid item xs={12} sm>
                      <Autocomplete
                        loading={loadingDirecciones}
                        required
                        disableClearable
                        inputValue={inputValueDirecciones}
                        id="buscar-direccion"
                        size="small"
                        loadingText="Buscando..."
                        noOptionsText={
                          inputValueDirecciones.length < 2
                            ? "Escriba al menos 2 caracteres..."
                            : filtrosSeleccionados.length === 0
                            ? "Seleccione al menos un filtro"
                            : loadingDirecciones
                            ? "Buscando..."
                            : "No se encontraron resultados"
                        }
                        options={todasDirecciones}
                        autoHighlight
                        filterOptions={(options) => options}
                        getOptionLabel={(direccion) =>
                          direccion
                            ? `${direccion.direccion_entrega} - ${direccion?.localidad}`
                            : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.id === value?.id
                        }
                        value={direccionSeleccionada}
                        onChange={(event, newValue) => {
                          handleDireccionSeleccionada(newValue);
                        }}
                        onInputChange={(event, newInputValue) => {
                          setInputValueDirecciones(newInputValue);
                        }}
                        renderOption={(props, option) => (
                          <Box component="li" {...props} sx={{ py: 1.5 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 6,
                                  height: 6,
                                  borderRadius: "50%",
                                  backgroundColor: "primary.main",
                                  flexShrink: 0,
                                }}
                              />
                              <Box sx={{ minWidth: 0, flex: 1 }}>
                                <Typography
                                  variant="subtitle2"
                                  fontWeight="600"
                                  noWrap
                                >
                                  {option.direccion_entrega}
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    mt: 0.5,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {option.localidad}
                                  </Typography>
                                  <Box
                                    sx={{
                                      width: 3,
                                      height: 3,
                                      borderRadius: "50%",
                                      backgroundColor: "grey.400",
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    color="text.primary"
                                    fontWeight="500"
                                  >
                                    {option.razon_social}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={getPlaceholderText(
                              filtrosSeleccionados
                            )}
                            label="Buscar cliente/dirección"
                            size="small"
                            error={filtrosSeleccionados.length === 0}
                            helperText={
                              filtrosSeleccionados.length === 0
                                ? "Seleccione al menos un filtro"
                                : ""
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                height: 40,
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingDirecciones ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={16}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm="auto">
                      <Box
                        sx={{
                          display: "flex",
                          gap: 0.5,
                          height: 40,
                          alignItems: "center",
                          justifyContent: {
                            xs: "flex-start",
                            sm: "flex-end",
                          },
                        }}
                      >
                        <Tooltip title="Agregar Cliente">
                          <IconButton
                            size="small"
                            onClick={handleClickNuevo}
                            sx={{
                              width: 36,
                              height: 36,
                              border: "1px solid",
                              borderColor: "grey.300",
                              backgroundColor: "white",
                            }}
                          >
                            <PersonAddAltIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Chips de filtros activos */}
                  <ChipsFiltrosActivos
                    filtrosSeleccionados={filtrosSeleccionados}
                    onFiltrosChange={handleFiltrosChange}
                  />
                </Box>
              </Grid>

              {/* Listado de clientes agregados */}
              <Grid item xs={12}>
                {clientesAgregados.length > 0 ? (
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      padding: "10px",
                      backgroundColor: "#f9f9f9",
                      maxHeight: "150px",
                      overflowY: "auto",
                    }}
                  >
                    <Grid container>
                      <Grid item xs={6} mb={1}>
                        <Typography
                          fontSize={18}
                          fontWeight="bold"
                          color="#1F618D"
                        >
                          Clientes Seleccionados:
                        </Typography>
                      </Grid>
                      <Grid item xs={6} mb={1}>
                        <TextField
                          fullWidth
                          size="small"
                          type="search"
                          placeholder="Buscar cliente..."
                          value={searchCliente}
                          onChange={(e) => setSearchCliente(e.target.value)}
                        />
                      </Grid>
                    </Grid>

                    <ClientesSeleccionadosList
                      clientesFiltrados={clientesAgregados.filter(
                        (item) =>
                          item.cliente.razon_social
                            .toLowerCase()
                            .includes(searchCliente.toLowerCase()) ||
                          item.direccion.direccion_entrega
                            .toLowerCase()
                            .includes(searchCliente.toLowerCase())
                      )}
                      handleEliminarCliente={handleEliminarCliente}
                    />
                  </Box>
                ) : (
                  <Typography
                    fontSize={16}
                    color="gray"
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    No hay clientes seleccionados.
                  </Typography>
                )}
                {
                  AdvertenciaCoordenadas? 
                  null
                  :<Typography fontSize={13} textAlign={"center"} alignContent={"center"} color={"error"}>Todos los clientes deben tener sus coordenadas cargadas</Typography>
                }
              </Grid>
              {/* Botones de acción */}
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                mt={1}
              >
                <Grid>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={handleClose}
                    style={{ backgroundColor: "#fff" }}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid>
                  <Button
                    type="submit"
                    color="success"
                    variant="contained"
                    disabled={disBtn}
                    
                  >
                    Guardar ({clientesAgregados.length})
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>
)}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>

      {altaCliente && (
  <Dialog
    open={altaCliente}  // ← Usa el estado interno
    onClose={() => setAltaCliente(false)}  // ← Cierra con el estado interno
    fullScreen
    // onClose={() => props.setOpen(false)}
  >
    <TabAltaEnv 
      alta={setAltaCliente} 
      tabla={setTabla}
      // onClose={() => setAltaCliente(false)}  // ← Para cerrar desde TabAltaEnv si es necesario
    />
  </Dialog>
)}

      {abrirCoordenadas ? (
        <CoordenadasClientes
          open={abrirCoordenadas}
          setOpen={setAbrirCoordenadas}
          direccionSeleccionada={direccionSeleccionada}
          onClose={handleCloseAgregarCoordenadas}
        />
      ) : null}
    </>
  );
}

export default AddClienteHoja;
